<template>
    <div class="header">
        <div class="contain">
            <div class="logo">
                <a
                    @click="Index"
                    aria-current="page"
                    class="router-link-exact-active router-link-active"
                    ><img src="../assets/logo.png"
                /></a>
            </div>
            <div class="nav">
                <ul>
                    <li>
                        <a
                            @click="Index"
                            aria-current="page"
                            class="router-link-exact-active router-link-active"
                            style="cursor: pointer;"
                            >首页</a
                        >
                    </li>
                    <li >
                        <a @click="srcm" style="cursor: pointer;">
                            数字智能SCRM
                            <!-- 
                            <div class="alist disNone">
                                <div
                                    v-for="(item, index) in Tabs"
                                    :key="index"
                                    @click="disNone(item.path)"
                                >
                                    {{ item.text }}
                                </div>
                            </div> -->
                        </a>
                    </li>
                    <!--                     
                    <li class="product">
                        <a href="javascript:;">
                            营销推广
                            <div class="alist disNone">
                                <div
                                    v-for="(item, index) in Tabst"
                                    :key="index"
                                    @click="disNone(item.path)"
                                >
                                    {{ item.text }}
                                </div>
                            </div>
                        </a>
                    </li> -->

                    <li>
                        <a @click="caseList" style="cursor: pointer;">精选案例</a>
                    </li>
                    <!-- <li>
                        <a class=""> 我们的触客渠道</a>
                    </li> -->
                    <li>
                        <a @click="about" style="cursor: pointer;">关于我们</a>
                    </li>
                    <li class="last">
                        <a @click="denglu" style="cursor: pointer;">立即试用</a>
                    </li>
                    <li class="last">
                        <a @click="chk" style="cursor: pointer;">综合触客平台</a>
                    </li>
                </ul>
            </div>
        </div>
        <!---->
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            Tabs: [
                {
                    text: "企微私域管理平台",
                    path: "/scrm",
                },
                // {
                //     text: "全员营销平台",
                //     path: "/hdcrm",
                // },
                // {
                //     text: "公众号运营平台",
                //     path: "/pmr",
                // },
                // {
                //     text: "营销活动平台",
                //     path: "/yxhdcrm",
                // },
                // {
                //     text: "e通码",
                //     path: "/h5crm",
                // },
                // {
                //     text: "专区速搭平台",
                //     path: "/cube",
                // },
                // {
                //     text: "数据分析平台",
                //     path: "/datacrm",
                // },
            ],

            Tabst: [
                {
                    text: "策略制定",
                    path: "/",
                },
                {
                    text: "运营维护",
                    path: "/",
                },
                {
                    text: "私域运营",
                    path: "/",
                },
                {
                    text: "包装传播",
                    path: "/",
                },
            ],
        };
    },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    methods: {
        nolond() {},
        disNone(path, id) {
            this.$router.push(path);
        },
        denglu() {
            this.$router.push({
                path: "/login",
            });
        },
        about() {
            this.$router.push({
                path: "/about",
            });
        },
        caseList() {
            this.$router.push({
                path: "/caseList",
            });
        },
        Index() {
            this.$router.push({
                path: "/",
            });
        },
        srcm(){
            this.$router.push({
                path: "/scrm",
            });
        },
        chk(){
            this.$router.push({
                path: "/zhchkpt",
            });
        }
    },
};
</script>
<style scoped>
@import "../../static/app.css";
</style>


// WEBPACK FOOTER //
// src/components/header1.vue